<template>
  <div class="login-container">
    <div class="wrap" v-if="wechatLogin">
      <el-form :model="form" :rules="rules" hide-required-asterisk ref="form">
        <img src="" alt="" class="logo">
        <div class="login-type">
          <span :class="{ active: form.platformType === 1 }" @click="changeType">{{ $t('login_account_login') }}</span>
          <span :class="{ active: form.platformType === 2 }" @click="changeType" v-if="smsCodeLogin">{{
            $t('login_dynamicCode_login') }}</span>
        </div>
        <template v-if="form.platformType === 1">
          <el-form-item prop="userName">
            <el-input v-model="form.userName" :placeholder="$t('login_input_username')"
              prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" type="password" show-password :placeholder="$t('login_input_password')"
              prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox>{{ $t('login_remember_password') }}</el-checkbox>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item prop="mobilePhone">
            <el-input v-model="form.mobilePhone" :placeholder="$t('login_input_mobilePhone')"
              prefix-icon="el-icon-phone"></el-input>
          </el-form-item>
          <!-- 动态验证码 verifyCode -->
          <el-form-item prop="verifyCode">
            <el-input :placeholder="$t('login_input_verifyCode')" v-model="form.verifyCode">
              <template slot="append">
                <el-button type="info" style="width:120px;background-color: #A62324;color: #fff;margin-right: -21px;"
                  @click="sendVerifyCode" :disabled="isCounting">{{
                    buttonText }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <!-- 图片验证码 code -->
          <el-form-item prop="code">
            <el-input :placeholder="$t('login_input_code')" v-model="form.code">
              <template slot="append">
                <canvas ref="captchaCanvas" @click="getCode" slot="append" class="code-canvas"></canvas>
              </template>
            </el-input>
          </el-form-item>
        </template>
        <el-button type="primary" @click="login">{{ $t('login') }}</el-button>
        <!-- <el-link class="home" type="primary" @click="$router.push('/home')">稍后登录</el-link> -->
      </el-form>
      <div class="code-wrap">
        <img src="@/assets/code.png" alt="">
        <el-button type="success" size="medium" style="width: 180px;">{{ $t('login_wechat_login') }}</el-button>
        <div class="notes">
          <div>{{ $t('login_wechat_scan_login') }}</div>
          <div>{{ $t('login_school_verify') }}</div>
        </div>
      </div>
    </div>
    <div class="wrap2" v-else>
      <el-form :model="form" :rules="rules" hide-required-asterisk ref="form">
        <img src="" alt="" class="logo">
        <div class="login-type">
          <span :class="{ active: form.platformType === 1 }" @click="changeType">{{ $t('login_account_login') }}</span>
          <span :class="{ active: form.platformType === 2 }" @click="changeType" v-if="smsCodeLogin">{{
            $t('login_dynamicCode_login') }}</span>
        </div>
        <div v-if="form.platformType === 1" key="first_form">
          <el-form-item prop="userName">
            <el-input v-model="form.userName" :placeholder="$t('login_input_username')"
              prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" type="password" show-password :placeholder="$t('login_input_password')"
              prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="rememberPassword">{{ $t('login_remember_password') }}</el-checkbox>
          </el-form-item>
        </div>
        <div v-if="form.platformType === 2" key="second_form">
          <el-form-item prop="mobilePhone">
            <el-input v-model="form.mobilePhone" :placeholder="$t('login_input_mobilePhone')"
              prefix-icon="el-icon-phone"></el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-input :placeholder="$t('login_input_verifyCode')" v-model="form.verifyCode">
              <template slot="append">
                <el-button type="info" style="width:120px;background-color: #A62324;color: #fff;margin-right: -21px;"
                  @click="sendVerifyCode" :disabled="isCounting">{{
                    buttonText }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input :placeholder="$t('login_input_code')" v-model="form.code">
              <template slot="append">
                <canvas ref="captchaCanvas" @click="getCode" slot="append" class="code-canvas"></canvas>
              </template>
            </el-input>
          </el-form-item>
        </div>
        <el-button type="primary" @click="login">{{ $t('login') }}</el-button>
        <!-- <el-link class="home" type="primary" @click="$router.push('/home')">稍后登录</el-link> -->
      </el-form>
    </div>
    <el-radio-group v-model="language" class="language" @change="switchLang">
      <el-radio-button label="zh">中文</el-radio-button>
      <el-radio-button label="en">English</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api'
import md5 from '@/utils/md5'
export default {
  name: 'Login',
  data() {
    var validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_username_required')))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_password_required')))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_mobilePhone_required')))
      } else {
        if (/^1[3-9]\d{9}$/.test(value)) {
          callback()
        } else {
          callback(new Error(this.$t('login_mobilePhone_format')))
        }
      }
    }
    // 图片验证码
    var validateCode = (rule, value, callback) => {
      console.log("🧑🏻‍💻 ~ value:", value)
      if (!value) {
        callback(new Error(this.$t('login_code_required')))
      } else if (value.toLowerCase() !== this.captchaText.toLowerCase()) {
        callback(new Error(this.$t('login_code_incorrect')))
      } else {
        callback()
      }
    }
    // 动态验证码
    var validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login_verifyCode_required')))
      } else {
        callback()
      }
    }
    return {
      language: 'zh',
      jumpURL,
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      // 控制验证码登录的隐藏与显示
      smsCodeLogin: false,
      // 控制微信登录的隐藏与显示
      wechatLogin: false,
      // 新增记住密码状态
      rememberPassword: false,
      form: {
        userName: '',
        password: '',
        platformType: 1,
        mobilePhone: '',
        // 手机验证码
        code: '',
        // 图片验证码
        verifyCode: ''
      },
      // 存储生成的验证码文本
      captchaText: '',
      rules: {
        userName: [
          {
            required: true,
            validator: validateUserName,
            // message: this.$t('login_username_required'),
            trigger: ['change', 'blur']
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassword,
            // message: this.$t('login_password_required'),
            trigger: ['change', 'blur']
          }
        ],
        mobilePhone: [
          {
            required: true,
            validator: validatePhone,
            trigger: ['change', 'blur']
          }
        ],
        // 图片验证码
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: ['change', 'blur'],
          }
        ],
        // 动态验证码
        verifyCode: [
          {
            required: true,
            validator: validateVerifyCode,
            trigger: ['change', 'blur']
          }
        ]
      },
      redirect: '',
      isCounting: false, // 是否正在倒计时
      countdown: 60,   // 倒计时时长（秒）
      timer: null,     // 定时器
    }
  },
  computed: {
    // 按钮显示文本
    buttonText() {
      return this.isCounting ? `${this.countdown}秒后重试` : this.$t('login_get_verify_code')
    },
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async mounted() {
    // 可选：从本地存储加载保存的语言偏好
    const savedLang = localStorage.getItem('language')
    if (savedLang) {
      this.$i18n.locale = savedLang
    }

    // loginBg
    const { data: { settingValue: loginBg } } = await api.getConfigInfo('login_bg')
    localStorage.setItem('loginBg', loginBg)

    document.querySelector('.login-container').style.backgroundImage = `url(${this.baseUrl}${loginBg})`
    document.querySelector('.logo').src = `${this.baseUrl}${this.logo}`
  },
  async created() {
    const savedLang = localStorage.getItem('language')
    if (savedLang) {
      this.language = savedLang
      this.$i18n.locale = savedLang
    }

    // 新增：加载保存的用户信息
    const savedUser = localStorage.getItem('savedUser')
    if (savedUser) {
      const { userName, password } = JSON.parse(savedUser)
      this.form.userName = userName
      this.form.password = password
      this.rememberPassword = true
    }

    // 等待所有配置加载完成后再初始化验证码
    await Promise.all([
      api.getConfigInfo('sms_code_login'),
      api.getConfigInfo('wechat_login')
    ]).then(([smsRes, wechatRes]) => {
      this.smsCodeLogin = Number(smsRes.data.settingValue)
      this.wechatLogin = Number(wechatRes.data.settingValue)
    })
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    switchLang(val) {
      localStorage.setItem('language', val) // 存储语言到本地存储
      this.$i18n.locale = val
      // 添加表单重置，清除现有验证提示
      this.$refs.form.resetFields()
    },
    // 生成随机验证码文本
    generateRandomText(length = 4) {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz0123456789'
      let text = ''
      for (let i = 0; i < length; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.captchaText = text
      return text
    },
    // 绘制验证码到Canvas
    getCode() {
      const canvas = this.$refs.captchaCanvas
      if (!canvas) {
        console.log('canvas 不存在')
        return
      }
      const ctx = canvas.getContext('2d')
      canvas.width = 120
      canvas.height = 40
      if (!ctx) {
        console.log('无法或者canvas上下文')
        return
      }

      // 绘制背景
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // 生成随机文本
      const text = this.generateRandomText()

      // 绘制文本
      ctx.font = 'bold 20px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      // 随机颜色和位置
      for (let i = 0; i < text.length; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 100 + 50}, ${Math.random() * 100 + 50}, ${Math.random() * 100 + 50})`
        ctx.translate(15 + i * 25, 20)
        ctx.rotate((Math.random() - 0.5) * 0.3)
        ctx.fillText(text[i], 0, 0)
        ctx.setTransform(1, 0, 0, 1, 0, 0) // 重置变换
      }

      // 绘制干扰线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgb(${Math.random() * 150}, ${Math.random() * 150}, ${Math.random() * 150})`
        ctx.beginPath()
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height)
        ctx.stroke()
      }

      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = `rgb(${Math.random() * 200}, ${Math.random() * 200}, ${Math.random() * 200})`
        ctx.beginPath()
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, 2 * Math.PI)
        ctx.fill()
      }
    },
    sendVerifyCode() {
      // 先校验手机号
      if (!/^1[3-9]\d{9}$/.test(this.form.mobilePhone)) {
        this.$refs.form.validateField('mobilePhone')
        return
      }
      // 防止重复点击
      if (this.isCounting) return
      this.isCounting = true

      this.$message.success("验证码已发送")
      // 开始倒计时
      this.startCountdown()
      api.getCode({
        mobilePhone: this.form.mobilePhone,
        verifyCode: md5(this.form.mobilePhone)
      })
    },
    startCountdown() {
      this.isCounting = true
      const timer = setInterval(_ => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(timer)
          this.isCounting = false
          this.countdown = 60
        }
      }, 1000)
    },
    changeType() {
      this.form = {
        userName: '',
        password: '',
        mobilePhone: '',
        verifyCode: '',
        code: '',
        platformType: this.form.platformType === 1 ? 2 : 1
      }
      this.$nextTick(() => {
        this.form.platformType === 2 ? this.getCode() : ''
      })
      this.$refs.form.resetFields()
    },
    async login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { data: { token, expireTime, initPwd } } = this.form.platformType === 1 ? await api.accountLogin(this.form) : await api.phoneLogin(this.form)
          // 新增记住密码逻辑
          if (this.form.platformType === 1) {
            if (this.rememberPassword) {
              // 保存密码到本地存储
              localStorage.setItem('savedUser', JSON.stringify({
                userName: this.form.userName,
                password: this.form.password
              }))
            } else {
              // 清除本地存储的密码
              localStorage.removeItem('savedUser')
            }
          }
          this.redirect = this.$route.query.redirect_url
          if (this.redirect) {
            window.location.href = `${decodeURIComponent(this.redirect)}&token=${token}&expireTime=${expireTime}`
          } else {
            localStorage.setItem('sys_token', token)
            localStorage.setItem('expireTime', expireTime)
            localStorage.setItem('initPwd', JSON.stringify(initPwd))
            this.$router.push('/home')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-image: url(../../assets/login_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .wrap,
  .wrap2 {
    width: 500px;
    display: flex;
    backdrop-filter: blur(10px);

    .code-canvas {
      width: 120px;
      height: 38px;
      cursor: pointer;
      background-color: #f5f5f5;
      display: block;
    }

    ::v-deep.el-form {
      width: 100%;
      height: 590px;
      padding: 80px 100px;
      background: rgba(0, 0, 0, .4);
      border-radius: 10px 0 0 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      img {
        height: 60px;
        margin-bottom: 30px;
      }

      .login-type {
        width: 100%;
        line-height: 42px;
        font-weight: bold;
        color: $infoColor;
        display: flex;
        gap: 20px;
        border-bottom: 2px solid $infoColor;
        margin-bottom: 22px;

        span {
          cursor: pointer;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          overflow-wrap: break-word;
          margin-bottom: -2px;

          &:after {
            content: "";
            // display: block;
            width: 100%;
            height: 2px;
            background: #fff;
            transition: all .3s;
            display: none;
          }

          &.active {
            color: #fff;
            transition: all .3s;

            &::after {
              display: block;
            }
          }
        }
      }

      &-item__content {
        width: 300px;
      }

      .el-button {
        width: 300px;
        height: 40px;
        border: 0;
      }

      .login-btn {
        width: 100%;
        margin-top: 20px;

        &:hover {
          opacity: .9;
        }
      }

      .el-checkbox__label {
        color: $contentColor;
      }

      .home {
        margin-top: 20px;
      }
    }

    .code-wrap {
      height: 590px;
      background: rgba(0, 0, 0, .2);
      border-radius: 0 10px 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 100px 100px;
      // gap:30px;

      img {
        width: 180px;
      }

      .notes {
        color: #fff;
        text-align: center;
        font-size: 20px;
        line-height: 32px;
      }
    }
  }

  .wrap2 {
    ::v-deep.el-form {
      border-radius: 10px;
    }
  }

  .language {
    position: absolute;
    top: 50px;
    right: 50px;

    ::v-deep.el-radio-button__inner {
      width: 90px;
    }
  }
}
</style>
